import { render, staticRenderFns } from "./CardSearch.vue?vue&type=template&id=202008df&scoped=true&"
import script from "./CardSearch.vue?vue&type=script&lang=js&"
export * from "./CardSearch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "202008df",
  null
  
)

export default component.exports